import { safeCombineEpics } from '@cbridge-utils/redux-observable';
import { clearNonExistentParamEpic } from './_epics/clearNonExistentParam.epic';
import { clearSelectSymbolGroupEpic } from './_epics/clearSelectSymbolGroup.epic';
import { loadSymbolGroupsEpic } from './_epics/loadSymbolGroups.epic';
import { reloadSymbolGroupsEpic } from './_epics/reloadSymbolGroups.epic';
import { toggleSelectSymbolGroupEpic } from './_epics/toggleSelectSymbolGroup.epic';

export const symbolGroupsEpic = safeCombineEpics(
  clearNonExistentParamEpic,
  clearSelectSymbolGroupEpic,
  loadSymbolGroupsEpic,
  reloadSymbolGroupsEpic,
  toggleSelectSymbolGroupEpic,
);
